export const UserRouteAccessSetting = {
    "multiuser":{
        restrictedPages:[]
    },
    "singleuser":{
        restrictedPages:["/client-details"]
    },
    "beta_users":{
        restrictedPages:[]
    }
}

export const PageVersionsAccessSetting = {
    beta:{
        smart_ads:[
          ]
    },
    alpha:{

    }
}